module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-settings-selected@1x.png?0.0.53";